import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../styles/theme';
import {
  WebsiteSection,
  WebsiteSectionContainer,
  WebsiteLoginFeatureCard,
} from '../common/websiteSection';

const WhyHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing['2xl']};
`;

const WhyTitle = styled.h1`
  margin: 0 0 ${theme.spacing.md};
  font-size: clamp(1.75rem, 3.5vw, 2.5rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  color: var(--login-form-text);
`;

const WhyIntro = styled.p`
  margin: 0 auto;
  max-width: 52ch;
  font-size: ${theme.typography.fontSize.lg};
  line-height: 1.65;
  color: var(--login-form-muted);
`;

const WhyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  max-width: 960px;
  margin: 0 auto;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

const WhyCardBody = styled.p`
  margin: 0;
  color: var(--login-form-muted);
  line-height: 1.65;
  font-size: ${theme.typography.fontSize.base};

  strong {
    color: var(--login-form-text);
    font-weight: 600;
  }
`;

const WHY_CHOOSE_ITEMS = [
  {
    lead: 'Built for service businesses',
    text: 'Salons, spas, fitness studios, and field teams — Neat Schedule is designed around how you actually work.',
  },
  {
    lead: 'Everything in one place',
    text: 'Online booking, staff calendars, client profiles, reminders, and payments — no juggling separate tools.',
  },
  {
    lead: 'Booking that never sleeps',
    text: 'Let clients self-book online 24/7 with a flow that keeps your calendar full while you focus on service.',
  },
  {
    lead: 'Protect your revenue',
    text: 'Automated reminders, waitlists, and deposits help cut no-shows and keep chairs, rooms, and routes booked.',
  },
  {
    lead: 'Support from real people',
    text: 'Get help from a team that knows scheduling — not just docs and chatbots when something needs fixing.',
  },
  {
    lead: 'Grows with your business',
    text: 'Start solo or run multiple staff and locations — add team members, services, and locations as you scale.',
  },
];

export default function WhyChooseSection() {
  return (
    <WebsiteSection>
      <WebsiteSectionContainer>
        <WhyHeader>
          <WhyTitle>Why choose Neat Schedule</WhyTitle>
          <WhyIntro>
            One platform to book clients, manage your team, and run your business — without the spreadsheet chaos.
          </WhyIntro>
        </WhyHeader>

        <WhyGrid>
          {WHY_CHOOSE_ITEMS.map((item) => (
            <WebsiteLoginFeatureCard key={item.lead}>
              <WhyCardBody>
                <strong>{item.lead}:</strong> {item.text}
              </WhyCardBody>
            </WebsiteLoginFeatureCard>
          ))}
        </WhyGrid>
      </WebsiteSectionContainer>
    </WebsiteSection>
  );
}
